import { TableViewStore, BaseListViewStore } from 'core/stores';
import { GridBooleanCell } from 'core/components';
import applicationContext from 'core/utils/applicationContext';
import { InsuranceService } from 'application/import-reference/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';

@applicationContext
class NikoInsuranceManagementListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new InsuranceService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'niko-insurance-management',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
                edit: item => {
                    this.setChildNavigationTitle(i =>
                        i.id === item.id,
                        () => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.niko-insurance-management.edit',
                        { id: item.id }
                    )
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                        const response = await service.find({
                            ...params,
                            isNiko: true,
                            embed:'PlaceOfService,BranchOffice'
                        });

                        return response.data;
                    }
                }
            }
        });

        this.sync = async () => {
            this.loaderStore.suspend();
            this.tableStore.suspend();
            try {
                await service.nikoSync();
                await this.queryUtility.fetch();
                this.rootStore.notificationStore.success("Niko sync successfully done.");
            } catch (err) {
                this.rootStore.notificationStore.error(err && err.data && err.data.errors ? err.data.errors : 'Error occurred while trying to sync Niko insurances.');
            }
            this.tableStore.resume();
            this.loaderStore.resume();
        };

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'NIKO_INSURANCE_MANAGEMENT.LIST.COLUMNS.NAME'
                },
                {
                    key: 'pricingGroupName',
                    title: 'NIKO_INSURANCE_MANAGEMENT.LIST.COLUMNS.PRICING_GROUP',
                    sortable: false
                },
                {
                    key: 'placeOfService',
                    title: 'NIKO_INSURANCE_MANAGEMENT.LIST.COLUMNS.POS'
                },
                {
                    key: 'branchOffice',
                    title: 'NIKO_INSURANCE_MANAGEMENT.LIST.COLUMNS.BRANCH_OFFICE'
                },
                {
                    key: 'drainageBagAllowable',
                    title: 'NIKO_INSURANCE_MANAGEMENT.LIST.COLUMNS.DRAINAGE_BAG_ALLOWABLE',
                    width: 140
                },
                {
                    // displayFaultyValue renders the red x on false; without it false is a blank cell.
                    key: 'isDateSpanHold',
                    title: 'NIKO_INSURANCE_MANAGEMENT.LIST.COLUMNS.DATE_SPAN_HOLD',
                    cell: GridBooleanCell,
                    displayFaultyValue: true,
                    width: 140,
                    headerClassName: 'center'
                },
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
            }
        }));
    }
}

export default NikoInsuranceManagementListViewStore;
